import { render, staticRenderFns } from "./task_setcar.vue?vue&type=template&id=264e7862&scoped=true"
import script from "./task_setcar.vue?vue&type=script&lang=js"
export * from "./task_setcar.vue?vue&type=script&lang=js"
import style0 from "./task_setcar.vue?vue&type=style&index=0&id=264e7862&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264e7862",
  null
  
)

export default component.exports